import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Instagram, Linkedin } from "lucide-react";
import { IoLogoTiktok } from "react-icons/io5";
import LazyLoad from 'react-lazyload';
import horizontalLogo from "../assets/vespidHorizontalLogo.png";
import Hamburger from "./Hamburger";
import Button from "./Button";

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <div className="py-5 px-16 flex flex-row justify-center md:justify-between font-primaryFont">
      <div className="w-32">
        <Link to="/home">
          <LazyLoad>
            <img src={horizontalLogo} alt="Vespid logo" loading="lazy" />
          </LazyLoad>
        </Link>
      </div>
      <div className="z-50 block fixed bottom-24 right-5 md:hidden">
        {openMenu ? <Hamburger setOpenMenu={setOpenMenu} /> : undefined}
        <button
          onClick={() => setOpenMenu(!openMenu)}
          className="rounded-full bg-primaryYellow bg-opacity-80 p-3"
        >
          <Menu size={30} />
        </button>
      </div>
      <div className="hidden md:flex md:items-center">
        <Link
          to="/"
          className="mx-6 font-light md:text-xl hover:border-b hover:border-primaryYellow"
        >
          Home
        </Link>
        <Link
          to="/about"
          className="mx-6 font-light md:text-xl hover:border-b hover:border-primaryYellow"
        >
          About
        </Link>
        <Link
          to="/solutions"
          className="mx-6 font-light md:text-xl hover:border-b hover:border-primaryYellow"
        >
          Solutions
        </Link>
        <Button
          href="https://form.typeform.com/to/QGaX0cpb"
          target="_blank"
          variant="primary"
          type="hero"
          size="sm"
          className="mx-6"
          aria-label="Partner with Vespid - Opens partnership form in new tab"
        >
          Partner With Us
        </Button>
        <a
          href="https://www.instagram.com/vespid_my/"
          target="_blank"
          rel="noreferrer noopener"
          className="focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:rounded-md"
          aria-label="Follow Vespid on Instagram - Opens in new tab"
        >
          <Instagram className="ml-6 w-6 h-6 inline" aria-hidden="true" />
        </a>
        <a 
          href="https://www.linkedin.com/company/vespid" 
          target="_blank" 
          rel="noreferrer noopener"
          className="focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:rounded-md"
          aria-label="Connect with Vespid on LinkedIn - Opens in new tab"
        >
          <Linkedin className="ml-6 w-6 h-6 inline" aria-hidden="true" />
        </a>
        <a 
          href="https://www.tiktok.com/@vespid_my" 
          target="_blank" 
          rel="noreferrer noopener"
          className="focus:outline-none focus:ring-2 focus:ring-primaryYellow focus:rounded-md"
          aria-label="Follow Vespid on TikTok - Opens in new tab"
        >
          <IoLogoTiktok className="ml-6 w-6 h-6 inline" aria-hidden="true" />
        </a>

      </div>
    </div>
  );
};

export default Header;
